import UtilCref from '@cewe-designsystem/util_cref';
import UtilCookie from '@cewe-designsystem/util_cookie';
import { UtilLocalStorage } from '@cewe-designsystem/util_storage/dist';
// eslint-disable-next-line no-magic-numbers
export const MARKETING_SESSION_LIFETIME_MS = 365 * 24 * 3600 * 1000;
export const MARKETING_SESSION_URL_PARAM = 'cwo';
export const MARKETING_SESSION_KEY = 'CEWE_Customer';
export const MARKETING_SESSION_TEMP_STORAGE_KEY = 'Modified_CEWE_Customer';
export function transferMarketingSessionKey() {
    const cookieUtil = new UtilCookie();
    if (cookieUtil.isSet(MARKETING_SESSION_KEY)) {
        const cookieVal = cookieUtil.getCookie(MARKETING_SESSION_KEY);
        UtilLocalStorage.set(MARKETING_SESSION_KEY, cookieVal, MARKETING_SESSION_LIFETIME_MS);
        cookieUtil.deleteCookie(MARKETING_SESSION_KEY, '/');
        console.debug('migrate HP selection setting', cookieVal, UtilLocalStorage.get(MARKETING_SESSION_KEY));
    }
}
export function isAffiliateSession(keyAccount) {
    const utilCref = keyAccount ? new UtilCref(`${keyAccount}`) : new UtilCref(null);
    const cref = utilCref.getCrefFromCookies();
    return cref ? utilCref.isScidCref(cref) : false;
}
export function isMarketingSession(refresh = true) {
    transferMarketingSessionKey();
    let activeMarketingSession = UtilLocalStorage.get(MARKETING_SESSION_KEY) == '1';
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has(MARKETING_SESSION_URL_PARAM)) {
        sessionStorage.removeItem(MARKETING_SESSION_TEMP_STORAGE_KEY);
        activeMarketingSession = searchParams.get(MARKETING_SESSION_URL_PARAM) == 'true';
    }
    if (!sessionStorage.getItem(MARKETING_SESSION_TEMP_STORAGE_KEY) && refresh) {
        UtilLocalStorage.set(MARKETING_SESSION_KEY, activeMarketingSession ? '1' : null, MARKETING_SESSION_LIFETIME_MS);
        sessionStorage.setItem(MARKETING_SESSION_TEMP_STORAGE_KEY, '1');
    }
    return activeMarketingSession;
}
